import { BaseService } from './base-service';
import { HttpResponse } from '@/types/http';
import { OWASReport, Category, GetResultOWASReport } from '@/core/domain/owas-report';
import {
	GetOWASReportMapper,
	GetCategoriesMapper,
	UpdateOWASReport,
	GetResultOWASReportMapper
} from '@/core/mappers/owas-report';
import {
	OWASReportDTO,
	GetCategoriesDTO,
	UpdateOWASReportParamsDTO,
	GetOWASReportParamsDTO,
	UpdateOWASReportDTO,
	GetOWASReportResultParamsDTO,
	GetResultOWASReportDTO
} from '@/core/dto/owas-report';

export class OWASReportService extends BaseService<OWASReportDTO> {
	private static instance: OWASReportService;

	private constructor(public readonly basePath: string = '/ergonomic-tool/owas') {
		super();
	}

	public static getInstance(): OWASReportService {
		if (!OWASReportService.instance) {
			OWASReportService.instance = new OWASReportService();
		}
		return OWASReportService.instance;
	}

	async getReport(params: GetOWASReportParamsDTO): Promise<OWASReport> {
		const { organization_id, company_id, file_id } = params;
		const { data } = await this.getInstance().get<OWASReportDTO>(this.basePath + `/report/${file_id}`, {
			params: { organization_id, company_id }
		});
		return new GetOWASReportMapper(data).toDomain();
	}

	async getCategoryParts(): Promise<Category[]> {
		const { data } = await this.getInstance().get<GetCategoriesDTO[]>(this.basePath + '/category/parts');
		return new GetCategoriesMapper(data).toDomain();
	}

	async update({ id, ...params }: UpdateOWASReportParamsDTO): Promise<HttpResponse> {
		const { data } = await this.getInstance().put<UpdateOWASReportDTO>(this.basePath + `/report/${id}`, params);
		return new UpdateOWASReport(data).toTransform();
	}

	async getResults(params: GetOWASReportResultParamsDTO): Promise<GetResultOWASReport> {
		const url = this.basePath + `/report/${params.file_id}/result`;
		const { data } = await this.getInstance().get<GetResultOWASReportDTO>(url, { params });
		return new GetResultOWASReportMapper(data).toDomain();
	}
}
